import React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';

export default styled(({ className, children }) => (
  <div className={classnames('suggestion-container', className)}>{children}</div>
))`
  border-top-width: 0;
  border-radius: 0 0 0.25rem 0.25rem;
  box-shadow: 0 9px 17px -15px black inset;
  background: white;
`;
